"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_DIRECTIVES = void 0;
exports.ALLOWED_DIRECTIVES = {
    'base-uri': 'base-uri',
    'block-all-mixed-content': 'block-all-mixed-content',
    'child-src': 'child-src',
    'connect-src': 'connect-src',
    'default-src': 'default-src',
    'font-src': 'font-src',
    'form-action': 'form-action',
    'frame-ancestors': 'frame-ancestors',
    'frame-src': 'frame-src',
    'img-src': 'img-src',
    'manifest-src': 'manifest-src',
    'media-src': 'media-src',
    'navigate-to': 'navigate-to',
    'object-src': 'object-src',
    'plugin-types': 'plugin-types',
    'prefetch-src': 'prefetch-src',
    'referrer': 'referrer',
    'report-to': 'report-to',
    'report-uri': 'report-uri',
    'require-sri-for': 'require-sri-for',
    'require-trusted-types-for': 'require-trusted-types-for',
    'sandbox': 'sandbox',
    'script-src': 'script-src',
    'script-src-attr': 'script-src-attr',
    'script-src-elem': 'script-src-elem',
    'style-src': 'style-src',
    'style-src-attr': 'style-src-attr',
    'style-src-elem': 'style-src-elem',
    'trusted-types': 'trusted-types',
    'upgrade-insecure-requests': 'upgrade-insecure-requests',
    'webrtc': 'webrtc',
    'worker-src': 'worker-src',
};
//# sourceMappingURL=directives.js.map